import { render, staticRenderFns } from "./NavigateDetail.vue?vue&type=template&id=2c51602f&scoped=true&"
import script from "./NavigateDetail.vue?vue&type=script&lang=js&"
export * from "./NavigateDetail.vue?vue&type=script&lang=js&"
import style0 from "./NavigateDetail.vue?vue&type=style&index=0&id=2c51602f&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51602f",
  null
  
)

export default component.exports